import PropTypes from "prop-types"
import { map } from "lodash"
import classNames from "classnames"
import { List, ListItem, Grid, ListSubheader } from "@mui/material"
import { COLUMNS } from "../shapes"
import ValueWithTooltip from "../value-with-tooltip"

export default function Total({ row, columns }) {
  return <List>
    <ListSubheader disableSticky>
      <Grid container>
        <Grid item xs className="label" />
        {map(columns, ({ id, name }) => <Grid key={id} item xs>{name}</Grid>)}
      </Grid>
    </ListSubheader>
    <ListItem>
      <Grid container>
        {map(row, (value, index) => <Grid key={index} item xs className={classNames({ label: index === 0 })}><ValueWithTooltip value={value} /></Grid>)}
      </Grid>
    </ListItem>
  </List>
}

Total.propTypes = {
  row: PropTypes.array.isRequired,
  columns: COLUMNS.isRequired,
}
